import { extractTextFromQuillTrimmed } from '@/utils/quill.ts';
import {
  DocumentDuplicateIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import { ContentItem } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';
import { QueryDocumentSnapshot } from 'firebase/firestore';

interface IComparisonItems {
  items?: QueryDocumentSnapshot<ContentItem, ContentItem>[];
  onEditClick: (item: QueryDocumentSnapshot<ContentItem, ContentItem>) => void;
  onDuplicateClick: (
    item: QueryDocumentSnapshot<ContentItem, ContentItem>,
  ) => void;
  onDeleteClick: (
    item: QueryDocumentSnapshot<ContentItem, ContentItem>,
  ) => void;
}

export const ComparisonItems = ({
  items,
  onEditClick,
  onDuplicateClick,
  onDeleteClick,
}: IComparisonItems) => {
  if (!items?.length) {
    return <div className="text-gray-500"></div>;
  }
  return (
    <div className="flex flex-col gap-4 pt-6">
      <div className="flex flex-row flex-wrap gap-4">
        {items?.map((item) => (
          <div key={item.id} className="group/comparison-item relative">
            <ComparisonItem item={item} />
            <div className="invisible absolute top-0 flex h-full w-full items-start justify-end group-hover/comparison-item:visible">
              <div className="absolute -top-2 -right-3 flex flex-col gap-1">
                <Button size="icon" onClick={() => onEditClick(item)}>
                  <PencilIcon className="h-4 w-4" />
                </Button>
                <Button size="icon" onClick={() => onDuplicateClick(item)}>
                  <DocumentDuplicateIcon className="h-4 w-4" />
                </Button>
                <Button
                  size="icon"
                  color="negative"
                  onClick={() => onDeleteClick(item)}
                >
                  <TrashIcon className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function ComparisonItem({
  item,
}: {
  item: QueryDocumentSnapshot<ContentItem, ContentItem>;
}) {
  const itemData = item.data();
  return (
    <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
      <blockquote className="text max-w-md min-w-[300px] p-6 leading-6 font-semibold tracking-tight text-gray-900 sm:p-8 sm:leading-8">
        {extractTextFromQuillTrimmed(itemData.brandName)}
      </blockquote>
    </figure>
  );
}
